module.exports = __webpack_public_path__ + "img/collapse_left.1f28a67c.png";